import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "snackbar-container" }

import {useStore} from "vuex";
import {computed, watch} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSnackbar',
  setup(__props) {

const store = useStore()

const show = computed(() => store.state.snackbar.show)
const message = computed(() => store.state.snackbar.message)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "snackbar" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", { class: "app-snackbar" }, _toDisplayString(message.value), 513), [
          [_vShow, show.value]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})